module.exports = __webpack_public_path__ + "static/media/icon-prize.d2e4d1ad.png";